<template>
  <a-config-provider :locale="en_US">
    <div id="app" @click="playClickSound" v-cloak>
      <audio ref="clickAudio" preload="auto">
        <source src="@/assets/music/btn.mp3" type="audio/mpeg">
      </audio>
      <div class="loading" v-if="$store.state.spinning">
        <a-spin size="large"> </a-spin>
      </div>
      <a-back-top :visibilityHeight="100" :target="topTarget">
        <div class="ant-back-top-inner">
<!--          <div class="top-icon"><a-icon type="to-top" /></div>
          <div>Topo</div>-->
          <img src="@/assets/home/top.png">
        </div>
      </a-back-top>
      <!--   书签下载   -->
      <book-mark-label @onDownload="download()"/>
      <Header />
<!--      <button @click="$store.state.gameUrl = 'https://d174l1vij6dnas.cloudfront.net/Rabbit/index.html?accessKey=1748984-32nsjaix3bvsbsojoucudjxo1azrlkxo&gameId=66123'">测试游戏</button>-->
      <div class="main-content">
        <div class="main-body" id="content">
          <div class="center-content">
            <keep-alive>
              <router-view />
            </keep-alive>
          </div>
<!--          <Bottom />-->
        </div>
      </div>
      <LoginCheck />
      <PayModal v-if="$store.state.payModalVisible" />
      <!-- 加载游戏 -->
      <Iframe
        v-if="$store.state.gameUrl"
        :href="$store.state.gameUrl"
        :newStyle="'display: block !important;'"
      ></Iframe>
      <!-- 点击游戏提示/新用户注册登录提示-->
      <limitPops
        v-if="$store.state.joinGameTipsType != 0"
        :visible.sync="$store.state.joinGameTipsType != 0"
        :TipsType="$store.state.joinGameTipsType"
        @handleOk="handlelimit"
      />
    </div>
  </a-config-provider>
</template>

<script>
import Header from "@/components/Header";
import Bottom from "@/components/Bottom";
import LoginCheck from "@/components/LoginCheck";
import PayModal from "@/components/PayModal";
import en_US from "ant-design-vue/lib/locale-provider/en_US";
import moment from "moment";
import Iframe from "@/components/Iframe";
import limitPops from "@/view/home/components/limitPops";
import "moment/locale/en-au";
import BookMarkLabel from "@/components/BookMark/bookMarkLabel/index.vue";
import ConstConfig from "@/config/ConstConfig";
import webSocket_stomp from "@/utils/webSocket_stomp";
import { setOpenTips } from "@/handle/ChargeHandle";
moment.locale("en-au");

export default {
  name: "App",
  mixins:[webSocket_stomp],
  components: {
    BookMarkLabel,
    Header,
    Bottom,
    LoginCheck,
    PayModal,
    Iframe,
    limitPops,
  },
  data() {
    return {
      en_US,
      gameUrl: "https://www.baidu.com/",
      palyState: false, // 添加用户交互状态
    };
  },
  watch: {
    $route(val) {
      const H5AddClassName = "App-H5";
      const appNode = document.getElementById("app");
      if (val.meta.h5Layout) {
        appNode.classList.add(H5AddClassName);
      } else {
        appNode.classList.remove(H5AddClassName);
      }
    },
    //监听webSocket消息
    message(newValue,oldValue){
      // console.log("监听变化",newValue);
      // console.log('当前路由路径:', this.$route.path,this.$store.state.vipStep);
      // console.log('查询参数:', this.$route.query);
      // console.log('路由参数:', this.$route.params);
      if(newValue.indexOf("withdraw_withdrawFail") !== -1){// 提现失败
        //清空用户账户信息
        // localStorage.setItem(ConstConfig.LOCAL_CONST.USER_ACCOUNT,null);
        // localStorage.removeItem(ConstConfig.LOCAL_CONST.USER_ACCOUNT);
        localStorage.setItem(ConstConfig.LOCAL_CONST.WITHDRAW_FAIL_FLAG, "3");
        //刷新页面
        this.$router.go(0);
        // setOpenTips(0,this.$t("Withdraw.9"),this.$t("WithdrawPopups.5"),()=>{
        //   this.$router.go(0);//刷新页面
        // });
      }else if(newValue.indexOf("withdraw_withdrawSuccess") !== -1){// 提现成功
        localStorage.setItem(ConstConfig.LOCAL_CONST.WITHDRAW_FAIL_FLAG, "2");
        //刷新页面
        this.$router.go(0);
      }else if(newValue.indexOf("charge_success") !== -1){
        localStorage.setItem(ConstConfig.LOCAL_CONST.CHARGE_FLAG, "2");
        localStorage.setItem(ConstConfig.LOCAL_CONST.CHARGE_FLAG_STEP, newValue.split(",")[1]);
        //刷新页面
        this.$router.go(0);
        // if((this.$route.path === "/withdraw" && this.$store.state.vipStep ===7) || this.$route.path === "/pay"){
        //   //刷新页面
        //   this.$router.go(0);
        // }else{
        //   console.log("no refresh1:", this.$route.path);
        // }
      }else if(this.$route.path === "/withdraw" && newValue.indexOf("withdraw") !== -1 ){
        let failFlag = localStorage.getItem(ConstConfig.LOCAL_CONST.WITHDRAW_FAIL_FLAG);
        if (failFlag == "1" && newValue.indexOf("withdraw_withdrawFail") !== -1) {
          // window.location.reload()
          // setOpenTips(0,this.$t("Withdraw.9"),this.$t("WithdrawPopups.5"));
          localStorage.setItem(ConstConfig.LOCAL_CONST.WITHDRAW_FAIL_FLAG, "3");
        }
        //刷新页面
        this.$router.go(0);

      }else{
        console.log("no refresh2:", this.$route.path);
      }
    }
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.$store.state.deferredPrompt = e;
      if (e) {
        this.checkIsShowBookmark();
      }
    });

  },
  mounted() {
    // 添加全局点击事件监听
    document.addEventListener('click', this.playClickSound);
    // //初始化WebSocket
    // this.initWebSocket();
    //监听 iframe 消息
    window.addEventListener("message", this.handleGameMessage);
  },
  methods: {
    /** 游戏界面关闭 进行操作 **/
    handleGameMessage(event) {
      console.log("exit game handle", event)
      if (event.data == "closeIFrame") {
        this.$store.state.gameUrl = "";
        this.gameUrl = "";
      }else if(event.data == "closeWithdraw"){
        this.$store.state.gameUrl = "";
        this.gameUrl = "";
        this.$router.push("/withdraw")// 跳转到提现页面
      }
    },
    // 添加点击音效方法
    playClickSound() {
      if (!this.palyState) {
        this.palyState = true;
      }
      const audio = this.$refs.clickAudio;
      if (audio) {
        audio.volume = 0.5; // 设置音量
        audio.currentTime = 0; // 重置音频播放位置
        audio.play().catch(error => {
          console.log("播放点击音效失败", error);
        });
      }
    },
    topTarget() {
      return document.getElementById("content");
    },
    /**点击三方游戏弹窗操作回调*/
    handlelimit(val) {
      this.$store.state.joinGameTipsType = 0;
      switch (val) {
        /**充值*/
        case "onCharge":
          this.$store.commit("setPayModalVisible", true);
          break;
        /**已解锁游戏*/
        case "PG":
          this.handleScroll("PG");
          break;
      }
    },
    handleScroll(id) {
      this.$nextTick(() => {
        const anchorElement = document.getElementById(id);
        if (anchorElement) {
          anchorElement.scrollIntoView(true);
          //{ behavior: "smooth" }  // 过渡动画
        }
      });
    },

    /**
     * 书签
     */
    /**下载书签*/
    async download() {
      let deferredPrompt = this.$store.state.deferredPrompt;
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            localStorage.setItem(ConstConfig.LOCAL_CONST.IS_DOWNLOAD, "1");
          } else {
            console.log('User dismissed the A2HS prompt')
          }
          this.$store.state.deferredPrompt = null;
        })
      }
    },
    /** 是否显示下载书签弹窗 */
    checkIsShowBookmark() {
      let isDownload = localStorage.getItem(ConstConfig.LOCAL_CONST.IS_DOWNLOAD);
      if (isDownload !== "1") {
        this.$store.state.isShowBookmarkDialog = true;
      }else{
        this.$store.state.isShowBookmarkDialog = false;
      }
    }

  },
};
</script>

<style lang="less">
[v-cloak] {
  display: none !important;
}
html {
  font-size: 1.1px;
  //font-size: 0.055vw;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB,
    Microsoft Yahei, sans-serif !important;
}
html,
body {
  height: 100%;
  //height: 100vh;
  //overflow: hidden;
  -webkit-text-size-adjust: 100% !important;
  //background: #292d35 !important;
  background: url("@/assets/banner/bg.png") no-repeat center center;
  background-size: 100% 100% !important;
}
@media only screen and (min-width: 540px) {
  html {
    font-size: 2px;
  }
}
@media only screen and (max-width: 300px) {
  html {
    font-size: 0.6px;
  }
}
* {
  padding: 0;
  margin: 0;
}
#app {
  display: flex;
  flex-flow: column;
  height: 100%;
  font-size: 14rem;
  color: @theme-text-color;
  max-width: 749px;
  margin: auto;
}
.main-content {
  display: flex;
  flex: 1;
  overflow: hidden;
  .main-body {
    flex: 1;
    overflow: auto;
    //隐藏滚动条
    overflow-y: scroll;          /* 必须保留滚动能力 */
    scrollbar-width: none;       /* Firefox */
    -ms-overflow-style: none;    /* IE 10+ */
    //background: @default-main-bg-color;
    .center-content {
      width: @content-center-width;
      margin: auto;
    }
  }
}
.hide {
  display: none;
}
.link {
  color: @link-color;
  cursor: pointer;
}
.ant-back-top {
  bottom: (@bottom-nav-height+25rem) !important;
  width: 45rem !important;
  height: 45rem !important;
  right: 10rem !important;
}
.ant-back-top-inner {
  width: 45rem;
  height: 45rem;
  //background: #fff;
  display: flex;

  align-items: center;
  justify-content: center;
  box-shadow: @default-box-shadow;
  border-radius: 8rem;
  font-size: 11rem;
  flex-flow: column;
  .top-icon {
    width: 16rem;
    height: 16rem;
    background: @link-color;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 10rem;
  }
  img {
    width: 100%;
  }
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: unset !important;
}
.ant-menu-item-selected {
  color: unset !important;
}
.ant-menu-vertical .ant-menu-item {
  margin-top: 0 !important;
}
.ant-menu-vertical .ant-menu-item:not(:last-child) {
  margin-bottom: 0 !important;
}
.ant-menu-vertical > .ant-menu-item,
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {
  height: auto !important;
}
.van-password-input {
  margin: 0 !important;
}
.van-tab {
  padding: 0 10rem !important;
}
.align-left-tabs .van-tabs__wrap--scrollable .van-tab--complete {
  flex: unset;
}
.van-tabs__line {
  background-color: #1890ff !important;
}
.van-cell__title {
  flex: unset !important;
}
// [class*="van-hairline"]::after {
//   border: none !important;
//   border-bottom: 1rem solid #ddd !important;
// }
.ant-modal-body {
  padding: 12px 18px;
}

.loading {
  height: 100%;
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 100rem;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
}
.ant-modal-mask{
  background-color: rgba(0, 0, 0, 0.7) !important;
}
// @media only screen and (min-width: @screen-width2) and (max-width: @screen-width1) {
//   html {
//     font-size: 0.065vw;
//   }
// }
// @media only screen and (min-width: @screen-width3) and (max-width: @screen-width2) {
//   html {
//     font-size: 0.075vw;
//   }
// }
// @media only screen and (min-width: @screen-width4) and (max-width: @screen-width3) {
//   html {
//     font-size: 0.125vw;
//   }
// }
// @media only screen and (max-width: @screen-width4) {
// html {
//   font-size: 0.288vw;
// }
.main-content {
  padding-bottom: @bottom-nav-height;
  .main-body {
    // background: #0f131c;
    //background: url(@/assets/logo/BG.png) no-repeat center center;
    //background-color: @default-main-bg-color;
    background-size: 100% 100%;
    //padding: 10rem;
    overflow-x: hidden;
    padding-top: 0;
    .center-content {
      width: 100%;
      height: 100%;
    }
  }
}
.tabs-wrap {
  .ant-tabs-nav {
    .ant-tabs-tab {
      margin: 0;
    }
  }
}

.App-H5 {
  .bottom-wrap,
  .header-wrap {
    display: none !important;
  }
  .main-content {
    padding-bottom: 0;
  }
  .main-content {
    .main-body {
      padding: 0;
    }
  }
  .main-content .main-body .center-content {
    height: 100%;
  }
}
// .van-tabs__wrap--scrollable .van-tab--complete {
//   flex: 1 0 auto !important;
// }
// }
.ant-select-dropdown{
  //居中
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 auto !important;
  width: 90% !important;
  background-color: rgba(0, 0, 0, 0.85) !important;
  border-radius: 8rem !important;
}
.ant-select-dropdown-menu-item{
  font-size: 16rem !important;
  line-height: 22rem !important;
  color: white !important;
  border-radius: 8rem !important;
}
.ant-select-dropdown-menu-item-selected{
  color: #000000 !important;
  border-radius: 8rem !important;
}

/* 假设 toast 的容器类名为 .toast-container */
.van-toast {
  background-color: rgba(51, 51, 51, 0.9) !important; /* 背景颜色 */
  color: #fff !important;          /* 文字颜色 */
  border-radius: 8rem !important;   /* 圆角 */
  font-size: 16rem !important;       /* 字体大小 */
  //margin: 4rem 4rem !important;    /* 内边距 */
  height: 20rem !important;
}

/* 修改成功提示的样式 */
.toast-container.success {
  background-color: #4CAF50 !important;
}

/* 修改错误提示的样式 */
.toast-container.error {
  background-color: #F44336 !important;
}

</style>
